import useGetStoreNameAndUrl from "@v1/hooks/useGetStoreNameAndUrl";
import {
  selectDraftElementId,
  selectDraftElementType,
  selectProjectId,
} from "@v1/reducers/core-reducer";
import { selectTemplateEditorStoreProduct } from "@v1/reducers/template-reducer";
import { useEditorSelector } from "@v1/store/store";

export default function usePreviewBeforePublishInfo() {
  const { storeUrl } = useGetStoreNameAndUrl();
  const draftElementType = useEditorSelector(selectDraftElementType);
  const projectId = useEditorSelector(selectProjectId);
  const draftElementId = useEditorSelector(selectDraftElementId);
  const templateEditorProduct = useEditorSelector(
    selectTemplateEditorStoreProduct,
  );

  const baseUrl = `https://${storeUrl}/apps/alchemy/element/preview`;

  if (!draftElementId || !projectId) {
    return {
      url: baseUrl,
      previewUrlAvailable: false,
    };
  }

  const queryParams: Record<string, string> = {
    elementId: draftElementId,
    storeId: projectId,
  };

  if (draftElementType === "shopifyProductTemplate" && templateEditorProduct) {
    queryParams.productHandle = templateEditorProduct.handle;
  }

  const url = new URL(baseUrl);
  url.search = new URLSearchParams(queryParams).toString();

  return {
    url: url.href,
    previewUrlAvailable: true,
  };
}
